import React, { FC, ComponentProps } from 'react';
import { Text } from '@goodrx/matisse';
import moment from 'moment';
import { getUtcTimestamp, getTimestamp } from 'app/lib/time';

export const Timestamp: FC<{ local?: boolean; date: string; format?: string } & ComponentProps<typeof Text>> = ({
  date,
  format = 'M/D/YY',
  local = true,
  ...props
}) =>
  date ? (
    <Text {...props}>{local ? getTimestamp(moment.utc(date).local(), format) : getUtcTimestamp(date)}</Text>
  ) : null;
